import { defineAsyncComponent } from 'vue';

export const MODAL_REGISTRY = {
  SelfServiceUserEdit: {
    size: 'new-design',
    component: defineAsyncComponent(() => import('@/components/self-service/user/SelfServiceUserEdit.vue')),
  },
  SelfServiceUserManage: {
    size: 'new-design',
    component: defineAsyncComponent(() => import('@/components/self-service/user/SelfServiceUserManage.vue')),
  },
  MobileOverlayIdleLock: {
    size: 'overlay',
    component: defineAsyncComponent(() => import('@/components/domains/mobile/MobileOverlayIdleLock.vue')),
  },
  LoginGuideOpenBrowser: {
    size: 'small',
    component: defineAsyncComponent(() => import('@/components/domains/login/LoginGuideOpenBrowser.vue')),
  },
} as const;
